import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  margin-left: -10px;
  
  width: calc(100% + 10px);
  flex-direction: column;
  background-color: #E9ECEF;
  
  @media (min-width: 1025px) {
    height: 93vh;
  }
`;

export const SubWrapper = styled.div`
  margin: 0;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: 1025px) {
    margin-left: 16px;
    margin-right: 16px;
    flex-direction: row;
  }
  
  @media (min-width: 1921px) {
    margin: 0 24px;
  }
`;

export const MapWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.21);
  min-height: 700px;

  @media (min-width: 1025px) {
    min-height: 440px;
  }
`;
